import { render, staticRenderFns } from "./SearchReport.vue?vue&type=template&id=2d864f65"
import script from "./SearchReport.vue?vue&type=script&lang=js"
export * from "./SearchReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports